import axios, { extractData } from '@atheneum/api'
import { extendObservable, computed } from 'mobx'
import { stringifyYearMonth } from '@atheneum/api/dist/lib'

class PerformanceStore {
  constructor (staticData) {
    extendObservable(this, {
      loading: false,
      error: null,
      performances: [],
      employeeList: [],
      loadList: false,
      query: this.getEmptyQuery(),
      staticData,
      units: computed(() => {
        let noOfUnits = 0
        this.performances.map(p => {
          noOfUnits = noOfUnits + p.units
        })
        return noOfUnits.toFixed(2)
      })
    })
  }

  getEmptyQuery () {
    return {
      month: stringifyYearMonth(Date.now()),
      employeeId: ''
    }
  }

  loadEmployeeList () {
    this.loadList = true
    return axios
      .get('/api/employee/list')
      .then(res => {
        const responseData = extractData(res)
        this.employeeList.replace(responseData)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loadList = false
      })
  }

  filter () {
    this.loading = true
    let url = `/api/report/performance?month=${this.query.month}`
    if (this.query.employeeId) {
      url = url + `&employeeId=${this.query.employeeId}`
    }

    return axios
      .get(url)
      .then(res => {
        const responseData = extractData(res)
        const formattedPerformances = responseData.map(res => {
          const feeType = this.staticData.names.feeTypes[res.feeTypeId]
          return { ...res, feeType: feeType }
        })
        this.performances.replace(formattedPerformances)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  clearSearch () {
    this.query = this.getEmptyQuery()
    this.filter()
  }
}

export default PerformanceStore
